import { Download } from "@mui/icons-material";

export const download = (props) => {
  return <Download {...props} />;
};
